import { render, staticRenderFns } from "./FeeImportCOD.vue?vue&type=template&id=6df1a773&scoped=true&"
import script from "./FeeImportCOD.vue?vue&type=script&lang=js&"
export * from "./FeeImportCOD.vue?vue&type=script&lang=js&"
import style0 from "./FeeImportCOD.vue?vue&type=style&index=0&id=6df1a773&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df1a773",
  null
  
)

export default component.exports